(() => {
  const root = document.querySelector('[data-install-app]');
  if (!root) return;

  const button = root.querySelector('[data-install-button]');
  const status = root.querySelector('[data-install-status]');
  const installPanels = root.querySelectorAll('[data-install-state-panel]');
  const procedureTabs = root.querySelectorAll('[data-procedure-tab]');
  const procedurePanels = root.querySelectorAll('[data-procedure-panel]');
  const STORAGE_KEY = 'vineggiamo-pwa-installed';
  let deferredPrompt = null;
  let installedDetected = false;

  const isStandalone = () =>
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  const setInstallPanel = (name) => {
    installPanels.forEach((panel) => {
      panel.hidden = panel.dataset.installStatePanel !== name;
    });
    root.dataset.installState = name;
  };

  const selectProcedure = (name) => {
    procedureTabs.forEach((tab) => {
      const selected = tab.dataset.procedureTab === name;
      tab.setAttribute('aria-selected', selected.toString());
      tab.tabIndex = selected ? 0 : -1;
    });

    procedurePanels.forEach((panel) => {
      panel.hidden = panel.dataset.procedurePanel !== name;
    });
  };

  const markInstalled = () => {
    installedDetected = true;

    try {
      window.localStorage.setItem(STORAGE_KEY, Date.now().toString());
    } catch (_) {
      // Il controllo continua con gli altri segnali disponibili.
    }

    setInstallPanel('installed');
    status.textContent = '';
  };

  const hasLocalInstallMarker = () => {
    try {
      return Boolean(window.localStorage.getItem(STORAGE_KEY));
    } catch (_) {
      return false;
    }
  };

  const detectInstalledApp = async () => {
    if (isStandalone() || hasLocalInstallMarker()) {
      markInstalled();
      return;
    }

    if ('getInstalledRelatedApps' in window.navigator) {
      try {
        const relatedApps = await window.navigator.getInstalledRelatedApps();
        if (relatedApps.some((app) => app.platform === 'webapp')) {
          markInstalled();
          return;
        }
      } catch (_) {
        // API sperimentale: si passa al comportamento di riserva.
      }
    }

    setInstallPanel(deferredPrompt ? 'available' : 'manual');
  };

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    if (installedDetected) return;

    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (_) {
      // Il prompt nativo resta il segnale autorevole.
    }

    deferredPrompt = event;
    setInstallPanel('available');
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    markInstalled();
  });

  button.addEventListener('click', async () => {
    if (!deferredPrompt) {
      setInstallPanel('manual');
      root.querySelector('[data-procedures]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    button.disabled = true;
    await deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    deferredPrompt = null;
    button.disabled = false;

    if (choice.outcome === 'accepted') {
      markInstalled();
    } else {
      setInstallPanel('manual');
      status.textContent = 'Installazione non completata. Puoi riprovare quando vuoi.';
    }
  });

  procedureTabs.forEach((tab) => {
    tab.addEventListener('click', () => selectProcedure(tab.dataset.procedureTab));
  });

  const userAgent = window.navigator.userAgent.toLowerCase();
  selectProcedure(/iphone|ipad|ipod/.test(userAgent) ? 'safari' : (/android/.test(userAgent) ? 'android' : 'desktop'));
  detectInstalledApp();
})();
